import { UPDATE_ACTIVITY_STATUS } from '@/store/modules/users/types';

export default {
  [UPDATE_ACTIVITY_STATUS]: (state, payload) => {
    const inactivePeriodInSec = Math.trunc((Date.now() - new Date(payload.active_at).getTime()) / 1000);

    const data = {
      [payload.user_id]: {
        activeAt: payload.active_at,
        online: inactivePeriodInSec < 10
      }
    };

    state.lastActivity = { ...state.lastActivity, ...data };
  }
};
